import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
// import GUI from "lil-gui";
import * as CANNON from "cannon-es";
import { Sky } from 'three/addons/objects/Sky.js'


// Constants
const APPLECOUNT = 20
const NEWTONPOSITION = {
  x: 0,
  y: 0.3,
  z: 0.4
}
const newtonsAppleIndex = Math.floor(Math.random() * (APPLECOUNT + 1))
let hangingApplesIndices = Array.from({ length: APPLECOUNT }, (_, i) => i)
let droppedApplesIndices = [];

/**
 * Debug
 */
// const gui = new GUI();
let debugObject = {};
debugObject.dropApple = () => {

if (hangingApplesIndices.length === 0) {
  console.log('No more apples to drop!');
  alert('No more apples to drop!');
  return;
}
// Get a random index position from hangingApplesIndices
const randomPosition = Math.floor(Math.random() * hangingApplesIndices.length);

// Get the actual apple index from hangingApplesIndices
const appleIndex = hangingApplesIndices[randomPosition];

// Remove the index from hangingApplesIndices
hangingApplesIndices.splice(randomPosition, 1);


// Add the index to droppedApplesIndices
droppedApplesIndices.push(appleIndex);

// Drop the apple using the selected index
dropApple(appleIndex);
};

debugObject.reset = () => {
    for (const object of objectsToUpdate) {
        // remove body
        object.body.removeEventListener("collide", playHitSound)
        world.removeBody(object.body)

        // rebuild the array
        droppedApplesIndices.forEach((appleIndex) => {
          if(appleIndex === newtonsAppleIndex) {
            appleArray[appleIndex]?.position?.set(
              NEWTONPOSITION.x - 0.07,
              Math.random() + 1.5,
              NEWTONPOSITION.z - 0.07
            )
          } else {
            const radius = Math.random() + 0.3; // Random radius between 1 and 0.3
            const angle = Math.random() * Math.PI * 2; // Random angle between 0 and 2π
            appleArray[appleIndex]?.position?.set(
              radius * Math.cos(angle),
              Math.random() + 1.5,
              radius * Math.sin(angle),
            )
          }
    })
          hangingApplesIndices = Array.from({ length: APPLECOUNT }, (_, i) => i)
    }
    // empty array
    objectsToUpdate.splice(0, objectsToUpdate.length)
}
// gui.add(debugObject, "dropApple");
// gui.add(debugObject, "reset");

const drop = document.querySelector("#drop")
drop.addEventListener('click', () => debugObject.dropApple())
const dropText = document.querySelector("#dropText")
dropText.addEventListener('click', () => debugObject.dropApple())
const reset = document.querySelector("#reset")
reset.addEventListener('click', () => debugObject.reset())


/**
 * Base
 */
// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Sounds
 */
const hitSound = new Audio('/sounds/hit.mp3')
const ouchSound = new Audio('/sounds/ouch.mp3')

const playHitSound = (collision, soundType = 'hit') => {
    const impactStrength = collision.contact.getImpactVelocityAlongNormal() / 20
    const sound = soundType === 'ouch' ? ouchSound : hitSound
    if(impactStrength < 0.05) return
    else if(impactStrength <= 1){
        sound.volume = impactStrength
        if( soundType === 'hit') sound.currentTime = 0
        sound.play()
    }
    else {
        sound.volume = 1
        if( soundType === 'hit') sound.currentTime = 0
        sound.play()
    }
}

/**
 * Models
 */
const loaderElement = document.getElementById('loader'); // Get the loader element

const loadingManager = new THREE.LoadingManager(
() => { // Loaded
    // Hide the loader
    loaderElement.classList.add('hidden');

    // Optional: Fade out the loader for a smoother transition
    // loaderElement.style.opacity = 0;
    // setTimeout(() => {
    //     loaderElement.style.display = 'none'; // Remove from layout after fade
    // }, 500); // Adjust fade duration as needed
},
(url, itemsLoaded, itemsTotal) => { // Progress
    // Optional: Update a progress bar or display percentage
    const progress = (itemsLoaded / itemsTotal) * 100;
    console.log(`Loading: ${progress.toFixed(2)}%`);
    // loaderElement.textContent = `Loading: ${progress.toFixed(2)}%`; // Update loader text
},
(url) => { // Error
    console.error('Error loading:', url);
    loaderElement.textContent = 'Error loading model'; // Display error message
}
);

const gltfLoader = new GLTFLoader(loadingManager);
let appleArray = new Array(APPLECOUNT)

// apple
gltfLoader.load(
    '/models/apple.glb',
    (glb) =>
    {
      const apple = glb.scene.children[0]
      apple.scale.set(0.001, 0.001, 0.001)

      for(let i = 0; i < APPLECOUNT; i++) {
        const appleCopy = apple.clone(true) // true for deep clone

        if(i === newtonsAppleIndex){
          appleCopy?.position?.set(
            NEWTONPOSITION.x - 0.07,
            Math.random() + 1.5,
            NEWTONPOSITION.z - 0.07)
        } else {
          const radius = Math.random() + 0.3; // Random radius between 1 and 0.3
          const angle = Math.random() * Math.PI * 2; // Random angle between 0 and 2π
          appleCopy?.position?.set(
            radius * Math.cos(angle),
            Math.random() + 1.5,
            radius * Math.sin(angle),
          )
        }
        appleArray[i] = appleCopy
        scene.add(appleCopy)
      }
    },
)

// tree

gltfLoader.load(
  '/models/tree.glb',
  (glb) =>
  {
    const tree = glb.scene.children[0]
    tree.scale.set(0.4, 0.4, 0.15)
      scene.add(tree)
  },
)


// newton
gltfLoader.load(
  '/models/newton.glb',
  (glb) =>
  {
    const newton = glb.scene.children[0]
    newton.position.set(NEWTONPOSITION.x, NEWTONPOSITION.y, NEWTONPOSITION.z)
    newton.scale.set(0.3, 0.3, 0.25)
      scene.add(newton)
  },
)

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader();

// Floor
const floorAlphaTexture = textureLoader.load('/textures/floor/alpha.webp')
const floorColorTexture = textureLoader.load('/textures/floor/aerial_grass_rock_1k/aerial_grass_rock_diff_1k.webp')
const floorARMTexture = textureLoader.load('/textures/floor/aerial_grass_rock_1k/aerial_grass_rock_arm_1k.webp')
const floorNormalTexture = textureLoader.load('/textures/floor/aerial_grass_rock_1k/aerial_grass_rock_nor_gl_1k.webp')
const floorDisplacementTexture = textureLoader.load('/textures/floor/aerial_grass_rock_1k/aerial_grass_rock_disp_1k.webp')

floorColorTexture.colorSpace = THREE.SRGBColorSpace

floorColorTexture.repeat.set(8, 8)
floorARMTexture.repeat.set(8, 8)
floorNormalTexture.repeat.set(8, 8)
floorDisplacementTexture.repeat.set(8, 8)

floorColorTexture.wrapS = THREE.RepeatWrapping
floorARMTexture.wrapS = THREE.RepeatWrapping
floorNormalTexture.wrapS = THREE.RepeatWrapping
floorDisplacementTexture.wrapS = THREE.RepeatWrapping

floorColorTexture.wrapT = THREE.RepeatWrapping
floorARMTexture.wrapT = THREE.RepeatWrapping
floorNormalTexture.wrapT = THREE.RepeatWrapping
floorDisplacementTexture.wrapT = THREE.RepeatWrapping

const cubeTextureLoader = new THREE.CubeTextureLoader();

const environmentMapTexture = cubeTextureLoader.load([
  "/textures/environmentMaps/3/px.png",
  "/textures/environmentMaps/3/nx.png",
  "/textures/environmentMaps/3/py.png",
  "/textures/environmentMaps/3/ny.png",
  "/textures/environmentMaps/3/pz.png",
  "/textures/environmentMaps/3/nz.png",
]);

/**
 * Physics
 */
// World
const world = new CANNON.World();
world.gravity.set(0, -9.82, 0);

// For optimization
world.broadphase = new CANNON.SAPBroadphase(world)
world.allowSleep = true


// Material
const defaultMaterial = new CANNON.Material("default");

const defaultContactMaterial = new CANNON.ContactMaterial(
  defaultMaterial,
  defaultMaterial,
  {
    friction: 0.9,
    restitution: 0.1,
  }
);
world.addContactMaterial(defaultContactMaterial);
world.defaultContactMaterial = defaultContactMaterial;

// Floor
const floorShape = new CANNON.Plane();
const floorBody = new CANNON.Body();
floorBody.mass = 0;
floorBody.addShape(floorShape);
floorBody.quaternion.setFromAxisAngle(new CANNON.Vec3(-1, 0, 0), Math.PI * 0.5);
world.addBody(floorBody);


// Newton
const NewtonShape = new CANNON.Cylinder(0.4, 0.4, 0.5, 8);
const NewtonBody = new CANNON.Body();
const newtonMaterial = new CANNON.Material('newton')
NewtonBody.material = newtonMaterial
NewtonBody.mass = 0.4;
NewtonBody.addShape(NewtonShape);
NewtonBody.position.set(NEWTONPOSITION.x, NEWTONPOSITION.y, NEWTONPOSITION.z);
NewtonBody.addEventListener("collide", (collision) => playHitSound(collision, 'ouch'))
world.addBody(NewtonBody);
const newtonContactMaterial = new CANNON.ContactMaterial(
  newtonMaterial,
  defaultMaterial,
  {
      friction: 0.4,
      restitution: 0.8
  }
)
world.addContactMaterial(newtonContactMaterial)

/**
 * Floor
 */
const floor = new THREE.Mesh(
  new THREE.PlaneGeometry(20, 20, 100, 100),
  new THREE.MeshStandardMaterial({
    envMap: environmentMapTexture,
    envMapIntensity: 0.5,
    alphaMap: floorAlphaTexture,
    transparent: true,
    map: floorColorTexture,
    aoMap: floorARMTexture,
    roughnessMap: floorARMTexture,
    metalnessMap: floorARMTexture,
    normalMap: floorNormalTexture,
    displacementMap: floorDisplacementTexture,
    displacementScale: 0.3,
    displacementBias: -0.2
  })
);
floor.receiveShadow = true;
floor.rotation.x = -Math.PI * 0.5;
scene.add(floor);

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 2.1);
scene.add(ambientLight);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.set(1.5, 1, 3.5);
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Utils
 */
const objectsToUpdate = [];

// Drop apple

const dropApple = (index) => {

  const apple = appleArray[index]

  // Cannon.js Body
  const shape = new CANNON.Sphere(0.02);
  const body = new CANNON.Body({
    mass: 1,
    position: new CANNON.Vec3(0, 3, 0),
    shape: shape,
    material: defaultMaterial,
  });
  body.position.copy(apple.position);

  // Add random impulse
  const randomX = (Math.random() - 0.5) * 0.1;
  const randomZ = (Math.random() - 0.5) * 0.1;
  body.applyImpulse(
      new CANNON.Vec3(randomX, 0, randomZ),
      new CANNON.Vec3(0, 0, 0)
  );

  body.addEventListener("collide", playHitSound)
  world.addBody(body);

  // Save in objects to update
  objectsToUpdate.push({
    mesh: apple,
    body: body,
  });
};

/**
 * Sky
 */
const sky = new Sky()
sky.scale.setScalar(50)
scene.add(sky)

sky.material.uniforms['turbidity'].value = 2
sky.material.uniforms['rayleigh'].value = 0.3
sky.material.uniforms['mieCoefficient'].value = 0.4
sky.material.uniforms['mieDirectionalG'].value = 0.98
sky.material.uniforms['sunPosition'].value.set(0.3, 0.3, 0)

/**
 * Fog
 */
 scene.fog = new THREE.Fog('#ffffff', 3, 8)

/**
 * Animate
 */
const clock = new THREE.Clock();
let oldElapsedTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - oldElapsedTime;
  oldElapsedTime = elapsedTime;

  // Update physics
  world.step(1 / 60, deltaTime, 3);
  for (const object of objectsToUpdate) {
    object.mesh.position.copy(object.body.position);
    object.mesh.quaternion.copy(object.body.quaternion);
  }

  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
